module.exports = __webpack_public_path__ + "static/media/400417_01.092c358e.png";